import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { AuthHttpInterceptor, AuthModule } from '@auth0/auth0-angular';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SECURITY_MODULE_CONFIG, SecurityModuleConfig } from '../security/security-config';
import { AuthorizationTokenService } from '../security/services/authorization-token.service';
import { BridgeTokenService } from '../security/services/bridge-token.service';
import { BridgeComponent } from './bridge/bridge.component';
import { LoginAuth0Component } from './login-auth0/login-auth0.component';
import { Auth0ClientConfig } from './services/auth0-client-config';
import { LoginAuth0Service } from './services/login-auth0.service';


@NgModule({
  declarations: [
    LoginAuth0Component,
    BridgeComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    NgxSpinnerModule
  ],
  exports: [
    LoginAuth0Component,
    BridgeComponent
  ],
  providers: []
})
export class SecurityAuth0Module {
  static forRoot(config: SecurityModuleConfig): ModuleWithProviders<SecurityAuth0Module> {
    return {
      ngModule: SecurityAuth0Module,
      providers: [
        { provide: SECURITY_MODULE_CONFIG, useValue: config },
        ...(AuthModule.forRoot({
          domain: Auth0ClientConfig.getAuth0Domain(),
          clientId: Auth0ClientConfig.getAuth0ClientId(),
          cacheLocation: 'localstorage',
          authorizationParams: {
            redirect_uri: Auth0ClientConfig.getAuth0RedirectUri(),
            audience: 'AuthenticationBc'
          },
          httpInterceptor: {
            allowedList: [
              {
                // Usa * como comodín para todas las rutas de tu API
                uri: 'http://localhost:7071/api/authenticationBcV2',
                tokenOptions: {
                  authorizationParams: {
                    // Debe coincidir con el audience de arriba
                    audience: 'AuthenticationBc'
                  }
                }
              }
            ]
          }
        }).providers ?? []),
        BridgeTokenService,
        LoginAuth0Service,
        {
          provide: AuthorizationTokenService, useExisting: BridgeTokenService
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AuthHttpInterceptor,
          multi: true
        }
      ]
        
      
    }
  }
}
